// store/index.js
import { configureStore } from "@reduxjs/toolkit";
import userReducer from "./userSlice";
import documentReducer from "./documentSlice.js";
import cardReducer from "./selectedCard.js";
import companyReducer from "./companySlice";
import selectedUserReducer from "./selectedUserSlice.js";
import accountTypeReducer from "./accountTypeSlice.js";
import formReducer from "./onboardingFormSlice.js";
import inspecieTransferReducer from "./inspecie-transfer.js";
import {certificateReducer} from "./certificateSlice.js"
import contractReducer from "./contractSlice.js";

const store = configureStore({
  reducer: {
    user: userReducer,
    documents: documentReducer,
    cards: cardReducer,
    company: companyReducer,
    selectedUsers: selectedUserReducer,
    accountType: accountTypeReducer,
    form: formReducer,
    inspecieTransfer: inspecieTransferReducer,
    certificate:certificateReducer,
    contract: contractReducer
  },
});

export default store;
